/* gc-polish.js — goacto 2026-10-13 (+ batch 5: QR field required, see bottom)
   1) Shopify Subscriptions widget: replace the hard-coded "Auto-renews, skip or cancel anytime." line with the
      term that matches the selected plan (wording from /policies/subscription-policy).
   2) Cart / cart drawer: minus at quantity 1 removes the line (Dawn's cart.js rejects 0 < data-min=1). */
(function () {
  var POLICY = '/policies/subscription-policy';
  var TXT = {
    annual: 'Prepaid Annual is a one-time 12-month purchase (see Quantity). Monthly subscribe plans cancel anytime. ',
    founding: 'Prepaid Founding is a one-time 12-month purchase (see Quantity). Monthly subscribe plans cancel anytime. ',
    monthly: 'Monthly plan: auto-renews each month. Skip, pause or cancel anytime. ',
    none: 'Subscribe: Monthly plans cancel anytime. Prepaid 12-month packs are one-time under Quantity (shipped monthly by hand). '
  };
  function planKind(input) {
    var g = input.closest('.subscription_group');
    var name = ((g && g.querySelector('.group_name') || {}).textContent || '').toLowerCase();
    if (name.indexOf('founding') > -1) return 'founding';
    if (name.indexOf('annual') > -1 || name.indexOf('12-month') > -1) return 'annual';
    return 'monthly';
  }
  function update(fieldset) {
    var p = fieldset.querySelector('.shopify_subscriptions_app_policy');
    if (!p) return;
    var sel = fieldset.querySelector('input[data-radio-type="selling_plan"]:checked');
    var kind = sel ? planKind(sel) : 'none';
    if (p.dataset.gcKind === kind) return; // guard: avoids MutationObserver loop
    p.dataset.gcKind = kind;
    p.textContent = TXT[kind];
    var a = document.createElement('a'); a.href = POLICY; a.textContent = 'Subscription policy';
    p.appendChild(a);
  }
  function tagLabels(fieldset) {
    fieldset.querySelectorAll('input[data-radio-type="selling_plan"]').forEach(function (inp) {
      var k = planKind(inp); if (k === 'monthly') return;
      var span = inp.parentElement.querySelector('.title_and_price_wrapper > span');
      if (span && !span.dataset.gcTerm) { span.dataset.gcTerm = '1'; span.textContent = span.textContent.trim() + ' · 12-month term'; }
    });
  }
  function initSubs(root) {
    (root || document).querySelectorAll('.shopify_subscriptions_fieldset').forEach(function (fs) {
      tagLabels(fs); update(fs);
      if (!fs.dataset.gcBound) { fs.dataset.gcBound = '1'; fs.addEventListener('change', function () { update(fs); }); }
    });
  }

  // Cart minus at 1 -> remove line
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.quantity__button[name="minus"]');
    if (!btn || !btn.closest('cart-items, cart-drawer-items')) return;
    var qi = btn.closest('quantity-input'); var input = qi && qi.querySelector('.quantity__input');
    if (!input || parseInt(input.value, 10) > 1) return;
    var row = btn.closest('.cart-item'); var rm = row && row.querySelector('cart-remove-button');
    if (!rm) return;
    e.preventDefault(); e.stopImmediatePropagation();
    rm.click();
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initSubs(); }); else initSubs();
  // Section re-renders (variant change) replace the widget markup
  new MutationObserver(function (m) { if (m.some(function (r) { return r.addedNodes.length; })) initSubs(); })
    .observe(document.documentElement, { childList: true, subtree: true });
})();

/* ---------- Batch 5 (2026-10-13): QR / destination URL is required before add to cart ----------
   Coasters (8428719571135) and keychains (8347135836351). Dawn's product form is novalidate and
   submits by fetch, so the native `required` never fired. These capture-phase listeners run first
   on document, so they cover: product page Add to cart (and sticky/duplicate submit buttons),
   the quick-add modal (it re-renders the same snippet with a prefixed form id), cart drawer and
   cart notification flows (they start from the same submit), and the Buy it now button. */
(function () {
  var QR_PRODUCTS = ['8428719571135', '8347135836351'];
  var MSG_EMPTY = 'Add the website or link your QR code should open, then add to cart.';
  var MSG_BAD = 'That link doesn\'t look right. Use a full web address, like https://your-site.com';

  function normalise(v) {
    v = (v || '').trim();
    if (v && !/^[a-z][a-z0-9+.-]*:/i.test(v) && /^[^\s\/]+\.[^\s\/]{2,}/.test(v)) v = 'https://' + v;
    return v;
  }
  function isValidUrl(v) {
    try {
      var u = new URL(v);
      return (u.protocol === 'https:' || u.protocol === 'http:') && /\.[a-z]{2,}$/i.test(u.hostname) && !/\s/.test(v);
    } catch (e) { return false; }
  }
  function qrInputFor(form) {
    if (!form || !form.elements) return null;
    return form.elements.namedItem('properties[QR URL]') ||
      (form.id && document.querySelector('[data-gc-qr-required][form="' + form.id + '"]'));
  }
  function productIdOf(form) {
    var el = form && form.querySelector('input[name="product-id"]');
    return el ? String(el.value) : '';
  }
  function showError(input, msg) {
    var err = document.getElementById(input.getAttribute('aria-describedby') || '');
    input.setAttribute('aria-invalid', msg ? 'true' : 'false');
    if (!err) return;
    err.textContent = msg || '';
    err.hidden = !msg;
  }
  // Returns true when the form may be submitted.
  function check(form) {
    if (!form || !/\/cart\/add/.test(form.getAttribute('action') || '')) return true;
    var input = qrInputFor(form);
    if (!input) {
      // A card / quick-add form for a QR product with no field on screen: send the shopper to the product page.
      if (QR_PRODUCTS.indexOf(productIdOf(form)) > -1) {
        var link = form.closest('.card-wrapper, .card, li') && form.closest('.card-wrapper, .card, li').querySelector('a[href*="/products/"]');
        if (link) { window.location.href = link.href; return false; }
      }
      return true;
    }
    var v = normalise(input.value);
    if (v !== input.value) input.value = v;
    var msg = !v ? MSG_EMPTY : (isValidUrl(v) ? '' : MSG_BAD);
    showError(input, msg);
    if (msg) {
      input.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(function () { input.focus({ preventScroll: true }); }, 250);
      return false;
    }
    return true;
  }

  document.addEventListener('submit', function (e) {
    if (!check(e.target)) { e.preventDefault(); e.stopImmediatePropagation(); }
  }, true);

  // Buy it now (dynamic checkout) skips the submit event, so check on click.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.shopify-payment-button, shopify-accelerated-checkout, .shopify-payment-button__button');
    if (!btn) return;
    var pf = btn.closest('product-form'); var form = pf && pf.querySelector('form[action*="/cart/add"]');
    if (form && !check(form)) { e.preventDefault(); e.stopImmediatePropagation(); }
  }, true);

  // Clear the message as soon as the value becomes valid; tidy the value when the field loses focus.
  document.addEventListener('input', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('[data-gc-qr-required]') && t.getAttribute('aria-invalid') === 'true' && isValidUrl(normalise(t.value))) showError(t, '');
  });
  document.addEventListener('focusout', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('[data-gc-qr-required]') && t.value) t.value = normalise(t.value);
  });
})();
